import React, { Component } from 'react';
import axios from 'axios';

import { Banner } from '../../Components/Banner/banner.component';
import { Loader } from '../../Components/Loader/loader.component';
import { Listing } from '../../Components/Listing/listing.component';
import { MorePosts } from '../../Components/More Posts/more-posts.component';
import { NoResults } from '../../Components/No Results/no-results.component';
import Form from '../../Components/Form/form.component';
import FiltersDropdown from '../../Components/Filters Dropdown/filters-dropdown.component';

class Homepage extends Component {
  constructor() {
    super();

    this.state = {
      data: [],
      filtered: [],
      searchField: '',
      isLoaded: false,
      pageSize: 12,
      filters: [],
      channel: '',
      filtersOn: false
    }
  }

  scrollToTop = () => {
    const top = document.querySelector('.filters-dropdown').offsetTop;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: 'smooth'
    });
  }

  handleScrollToForm = () => {
    const top = document.querySelector('.form-wrapper').offsetTop;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: 'smooth'
    });
  }

  handleFilterClick = e => {
    const btn = e.target;
    btn.classList.toggle('active');
    const val = btn.dataset.value;
    const addedFilters = [...this.state.filters, val];
    const uniqueFilters = addedFilters.filter((data,index)=>{
      return addedFilters.indexOf(data) === index;
    });

    // Push selected filter to state
    if (btn.classList.contains('active')) {
        this.setState({
            filters: uniqueFilters
        });
    } 
    // Remove deselected filter from state
    else {
        var newArr = [...this.state.filters];
        var index = newArr.indexOf(val)
        if (index !== -1) {
            newArr.splice(index, 1);
            this.setState({
                filters: newArr
            });
        }
    }
  }

  handleDropdown = () => {
    const dropdown = document.querySelector('.dropdown-wrapper');
    dropdown.classList.toggle('active');
    
    const trigger = document.querySelector('.filters-trigger');
    trigger.classList.toggle('open');
  }

  handleChannelClick = e => {
    const btn = e.target;
    const allBtns = document.querySelectorAll('.filter.single')
    if (btn.classList.contains('active')){
        btn.classList.remove('active')
    } else {
        allBtns.forEach(el => {
            el.classList.remove('active')
        });
        btn.classList.add('active')
    }

    const channelSelected = document.querySelector('.filter.single.active');
    const val = btn.dataset.value;

    if (channelSelected == null) {
      this.setState({
        channel: '',
      })
    } else {
      this.setState({
          channel: val
      });
    }
  }

  handleClearFilters = () => {
    this.setState({
        filters: [],
        channel: '',
        filtersOn: false
    });

    const buttons = document.querySelectorAll('button.filter');
    buttons.forEach(button => button.classList.remove('active'));
    window.history.replaceState('', '', this.props.location.pathname);
  }

  setFilters = (data) => {
    const {channel, filters} = this.state;

    let filteredData = [];

    for(var arr in data){
        for(var filter in filters){
            if(data[arr].acf.content === filters[filter]){
                filteredData.push(data[arr]);
            }
        }
    }

    if (filters.length > 0) {
      if (channel) {
        filteredData = filteredData.filter(item => item.acf.industry.includes(channel))
      }
    } else {
      if (channel) {
        filteredData = data.filter(item => item.acf.industry.includes(channel))
      }
    }

    const filterActive = document.querySelector('.filter.active')
    
    if (filterActive == null) {
      this.setState({
        filtersOn: false,
        isLoaded: true
      })
    } else {
      this.setState({
        filtersOn: true,
        filtered: filteredData,
        isLoaded: true
      })
    }
  }

  handleApplyFilters = () => {
    this.scrollToTop();
    this.setFilters(this.state.data);
    this.handleDropdown();
    this.setSearchParams(); 
  }

  setSearchParams = () => {
    let searchQuery;
    let paramFilters = [];
    let uniqueFilters = [];

    if (this.state.channel && this.state.filters.length > 0) {
      paramFilters = [];
      this.state.filters.forEach(filter => {
        const newFilter = filter.replace(/ /g, '+');
        paramFilters.push(newFilter)
      })
      uniqueFilters = paramFilters.filter((data,index)=>{
        return paramFilters.indexOf(data) === index;
      })
      searchQuery = `?channel=${this.state.channel}&filters=${uniqueFilters}`
    } else if (this.state.channel && this.state.filters.length === 0) {
      searchQuery = `?channel=${this.state.channel}`
    } else if (!this.state.channel && this.state.filters.length > 0) {
      paramFilters = [];
      this.state.filters.forEach(filter => {
        const newFilter = filter.replace(/ /g, '+');
        paramFilters.push(newFilter)
      })
      uniqueFilters = paramFilters.filter((data,index)=>{
        return paramFilters.indexOf(data) === index;
      })
      searchQuery = `?filters=${uniqueFilters}`
    }

    if (searchQuery !== undefined) {
      window.history.replaceState('', '', searchQuery)
    }
  }

  handleSearch = (event) => {
    this.setState({ 
      searchField: event.target.value,
      pageSize: 12
    });

    this.scrollToTop();
  }

  handleMorePosts = () => {
    this.setState((prevState) => ({
      pageSize: prevState.pageSize + 12
    }))
  }

  fetchPosts = () => {
    const channel = new URLSearchParams(this.props.location.search).get("channel") !== null ? new URLSearchParams(this.props.location.search).get("channel") : '';
    const filters = new URLSearchParams(this.props.location.search).get("filters") !== null ? new URLSearchParams(this.props.location.search).get("filters").split(',') : [];
    const filtersOn = channel !== '' || filters.length !== 0 ? true : false;

    axios.get(`https://crowdriff.com/wp-json/wp/v2/showcase?per_page=100`)
      .then(res => {
        this.setState({
          data: res.data,
          channel: channel,
          filters: filters,
          filtersOn: filtersOn,
          isLoaded: true
        })
        this.setFilters(this.state.data)
      })
      .catch(err => console.log(err))

  }

  sortData = () => {
    this.state.data.sort((a,b) => parseFloat(b.acf.date) - parseFloat(a.acf.date))
  }

  componentDidMount() {
    this.fetchPosts();
    this.sortData();
  }

  render() {
    const { 
      data, 
      filtered, 
      searchField, 
      isLoaded, 
      pageSize, 
      filters, 
      channel, 
      filtersOn 
    } = this.state;

    let results;

    if (filtersOn) {
      results = filtered
    } else {
      results = data
    }

    if (searchField) {
      results = results.filter(item => item.title.rendered.toLowerCase().includes(searchField.toLowerCase()))
    }

    return (
      <div className="homepage">
        <Banner 
          handleClick={this.handleScrollToForm}
        />
        <FiltersDropdown
          data={data}
          handleDropdown={this.handleDropdown}
          handleClearFilters={this.handleClearFilters}
          handleChannelClick={this.handleChannelClick}
          handleFilterClick={this.handleFilterClick}
          handleApplyFilters={this.handleApplyFilters}
          filters={filters}
          channel={channel}
          handleSearch={this.handleSearch}
        />
        { !isLoaded &&
          <Loader />
        }
        { results.length > 0 && isLoaded ?
          (
            <div>
              <Listing 
                data={results}
                size={pageSize}
              />
              { pageSize < results.length &&
                <MorePosts
                  handleClick={this.handleMorePosts}
                />
              }
            </div>
          ) :
          (<NoResults />)
        }
        <Form />
      </div>
    )
  }
}

export default Homepage;
